var exports = {
  "Ur": "VoiceMessageRecorder.module__voiceButtonWrapper___TVBibV",
  "VK": "VoiceMessageRecorder.module__voiceButton___TVBibV",
  "qu": "VoiceMessageRecorder.module__voiceButtonIcon___TVBibV",
  "hB": "VoiceMessageRecorder.module__holdTooltip___TVBibV",
  "Yh": "VoiceMessageRecorder.module__recordingOverlay___TVBibV",
  "Zo": "VoiceMessageRecorder.module__overlayInner___TVBibV",
  "kK": "VoiceMessageRecorder.module__recordingControls___TVBibV",
  "PJ": "VoiceMessageRecorder.module__recordingBar___TVBibV",
  "lL": "VoiceMessageRecorder.module__recordingDot___TVBibV",
  "O1": "VoiceMessageRecorder.module__timer___TVBibV",
  "ou": "VoiceMessageRecorder.module__waveform___TVBibV",
  "hd": "VoiceMessageRecorder.module__waveformBar___TVBibV",
  "gb": "VoiceMessageRecorder.module__iconButton___TVBibV",
  "T5": "VoiceMessageRecorder.module__trashButton___TVBibV",
  "jo": "VoiceMessageRecorder.module__sendButton___TVBibV",
  "QO": "VoiceMessageRecorder.module__lockIndicatorWrapper___TVBibV",
  "zY": "VoiceMessageRecorder.module__lockIndicator___TVBibV",
  "bd": "VoiceMessageRecorder.module__lockIndicatorLocked___TVBibV",
  "GR": "VoiceMessageRecorder.module__lockIndicatorIcon___TVBibV",
  "c8": "VoiceMessageRecorder.module__lockIndicatorCaret___TVBibV",
};

module.exports = exports;
